import "../style/page/financialdashboard.scss";
import { useEffect, useState, useMemo } from "react";
import { financialdata } from "../../text/apidata";
import axios from "axios";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";


export default function FinancialDashboard(props) {
    const sideactive = useSelector((state) => state.counter.sidebarnav);
    const [data, setdata] = useState([]);
    const dispatch = useDispatch();
    const [pdfgenerate, setpdfgenerate] = useState("False");
    const locationid = useSelector((state) => state.counter.loginuser_location_id)

    const [branches, setbranches] = useState(locationid != "all" ? locationid : "91");

    const [islocationfilter, setislocationfilter] = useState([
        { value: "All", id: "all", disabled: locationid == "all" ? false : true },
        { value: "CHETPET", id: "90", disabled: locationid == "90" || locationid == "all" ? false : true },
        { value: "VELACHERY", id: "91", disabled: locationid == "91" || locationid == "all" ? false : true },
        { value: "KOLATHUR", id: "92", disabled: locationid == "92" || locationid == "all" ? false : true },
    ]);


    var today = new Date();
    var priorDate = new Date(new Date().setDate(today.getDate() - 30));
    var it = convert(today);
    var gt = convert(priorDate);
    const [range, setrange] = useState([it, it]);
    const startDate = range[0];
    const endDate = range[1];
    const dateRangeHeader = `${startDate} : ${endDate}`;
    useEffect(() => {
        props.loaderchange("true");
        axios({
            method: "get",
            url: financialdata,
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token") + "",
            },
            params: {
                date_gt: range[0],
                date_lt: range[1],
                branch: branches,
            },
        })
            .then((res) => {
                console.log(res.data.data, "index7687");
                setdata(res.data.data);
                props.loaderchange("false");
            })
            .catch((error) => {
                console.log(error);
                props.loaderchange("false");
                // setdtPageindex(dtpageindex-1)
                props.popupalert("true");
                props.popuptext("No Data Available");
                setTimeout(() => {
                    props.popupalert("false");
                }, 2000);
            });
    }, [range, pdfgenerate, branches]);

    function convert(str) {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
    }

    const handlechangedate = (name, value) => {
        if (value != null) {
            setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
        }
    };

    const predefinedBottomRanges = [
        {
            label: "Today",
            value: [new Date(), new Date()],
            placement: "left",
        },
        {
            label: "Yesterday",
            value: [addDays(new Date(), -1), addDays(new Date(), -1)],
            placement: "left",
        },
        {
            label: "This week",
            value: [startOfWeek(new Date()), endOfWeek(new Date())],
            placement: "left",
        },
        {
            label: "Last 30 days",
            value: [subDays(new Date(), 29), new Date()],
            placement: "left",
        },

        {
            label: "Last week",
            closeOverlay: false,
            value: (value, index) => {
                const [start = new Date()] = value[index] || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
                ];
            },
            appearance: "default",
        },
        {
            label: "Next week",
            closeOverlay: false,
            value: (value, index) => {
                // console.log(value);
                const [start = new Date()] = value[index] || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
                ];
            },
            appearance: "default",
        },
    ];

    const toIndianCurrency = (num) => {
        const curr = num.toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
        });
        return curr;
    };

    const datadownload = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do You Want To Download The Data?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                axios({
                    method: "get",
                    url: financialdata,
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token") + "",
                    },
                    params: {
                        date_gt: range[0],
                        date_lt: range[1],
                        generate: "True",
                        branch: branches,

                    },
                })
                    .then((res) => {
                        window.open(res.data.data, "_self");
                        // Swal.fire(
                        //   'Deleted!',
                        //   'Your file has been deleted.',
                        //   'success'
                        // )

                        console.log(res);
                    })
                    .catch((err) => { });
            }
        });
    };

    return (
        <>
            <div className={sideactive ? "dashboard-main-sa" : "dashboard-main"}>
                <div class="page-header">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3 class="page-title">
                                {"Welcome " + localStorage.getItem("role") + "!"}
                            </h3>
                            <ul
                                class="breadcrumb"
                                style={{ justifyContent: "space-between" }}
                            >
                                <li class="breadcrumb-item active">Financial DashBoard</li>
                                <li>
                                    {" "}
                                    <div className="datepicker_dash">
                                        <DateRangePicker
                                            defaultValue={[new Date(), new Date()]}
                                            disabledDate={(date) => isAfter(date, new Date())}
                                            editable={false}
                                            appearance="default"
                                            placement="bottomEnd"
                                            size="lg"
                                            ranges={predefinedBottomRanges}
                                            placeholder="From - To"
                                            style={{ width: 270, padding: 10, float: "right" }}
                                            onChange={(e) => {
                                                if (e != null) {
                                                    setrange([]);
                                                    e.forEach((newValue) => {
                                                        var tzoffset =
                                                            new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                                                        var localISOTime = new Date(newValue - tzoffset)
                                                            .toISOString()
                                                            .slice(0, -1);
                                                        handlechangedate("validtill", localISOTime);
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="card">
                        <div
                            align="center"
                            type="button"
                            style={{ display: "flex", justifyContent: "end", textAlign: "center", margin: 5 }}

                        >
                            <a class="dnbtn" onClick={(e) => {
                                datadownload();
                            }}></a>
                        </div>

                        <div className="card-body" style={{ padding: "1.5rem" }}>
                            <div className="row">
                                <div className="col-3">
                                    <div className="w-100 rounded d-flex">
                                        <label class="form-label mb-0 align-self-center mr-2" style={{ width: "100px" }}>
                                            Branch
                                        </label>

                                        <select
                                            class="form-select w-9 0"
                                            id="validationCustom04"
                                            value={branches}
                                            name="IsActive"
                                            onChange={(e) => {
                                                setbranches(e.target.value);
                                            }}
                                            required
                                        >
                                            <option value={""} selected disabled>
                                                Filter By Location...
                                            </option>
                                            {islocationfilter.map((data) => {
                                                return (<>{!data.disabled ? <option value={data.id} disabled={data.disabled}>{data.value}</option> : ""}</>);
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive">
                                {Object.keys(data).length > 0 && <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">{dateRangeHeader}</th>
                                            <th scope="col">Cash Back 1%</th>
                                            <th scope="col">Cash Back 5%</th>
                                            <th scope="col">Cash Back 5%</th>

                                            <th scope="col">Cash Back 5%</th>
                                            <th scope="col"></th>
                                            <th scope="col">Cash Back 5%</th>
                                            <th scope="col"></th>
                                        </tr>
                                        <tr>
                                            <th scope="col"></th>
                                            <th scope="col">IP BILLS</th>
                                            <th scope="col">PHARMACY</th>
                                            <th scope="col">OP SERVICES</th>

                                            <th scope="col">PHARMACY ORDER</th>
                                            <th scope="col">DIAGNOSTICS</th>
                                            <th scope="col">APPOINTMENTS</th>

                                            <th scope="col">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td scope="row">Collection</td>
                                            <td scope="row">{toIndianCurrency(data.ip_bill.base_amount_ip)} </td>
                                            <td scope="row">{toIndianCurrency(data.op_pharma.base_amount_op_pharma)} </td>
                                            <td scope="row">{toIndianCurrency(data.op.base_amount_op)} </td>

                                            <td scope="row">{toIndianCurrency(data.ph.base_amount_ph)} </td>
                                            <td scope="row">{toIndianCurrency(data.di.base_amount_di)} </td>
                                            <td scope="row">{toIndianCurrency(data.ap.base_amount_ap)} </td>

                                            <td scope="row">{toIndianCurrency(data.total.base_amount_total)}</td>
                                        </tr>
                                        <tr>
                                            <td scope="row">Cash Back</td>
                                            <td scope="row"> {toIndianCurrency(data.ip_bill.cashback_received_ip)} </td>
                                            <td scope="row"> {toIndianCurrency(data.op_pharma.cashback_received_op_pharma)}</td>
                                            <td scope="row">{toIndianCurrency(data.op.cashback_received_op)}</td>

                                            <td scope="row">{toIndianCurrency(data.ph.cashback_received_ph)} </td>
                                            <td scope="row">{toIndianCurrency(data.di.cashback_received_di)} </td>
                                            <td scope="row">{toIndianCurrency(data.ap.cashback_received_ap)} </td>

                                            <td scope="row">{toIndianCurrency(data.total.cashback_recieved)}</td>
                                        </tr>
                                        <tr>
                                            <td scope="row"> Cask Back Utilised</td>
                                            <td scope="row">{toIndianCurrency(data.ip_bill.used_cashbackpoints_ip)}</td>
                                            <td scope="row">{toIndianCurrency(data.op_pharma.used_cashbackpoints_op_pharma)}</td>
                                            <td scope="row">{toIndianCurrency(data.op.used_cashbackpoints_op)}</td>

                                            <td scope="row">{toIndianCurrency(data.ph.used_cashbackpoints_ph)} </td>
                                            <td scope="row">{toIndianCurrency(data.di.used_cashbackpoints_di)} </td>
                                            <td scope="row">{toIndianCurrency(data.ap.used_cashbackpoints_ap)} </td>

                                            <td scope="row">{toIndianCurrency(data.total.used_cashback)}</td>
                                        </tr>
                                        <tr>
                                            <td scope="row">Collection After Cash Back</td>
                                            <td scope="row">{toIndianCurrency(data.ip_bill.bill_amount_ip)}</td>
                                            <td scope="row">{toIndianCurrency(data.op_pharma.bill_amount_op_pharma)}</td>
                                            <td scope="row">{toIndianCurrency(data.op.bill_amount_op)}</td>

                                            <td scope="row">{toIndianCurrency(data.ph.bill_amount_ph)} </td>
                                            <td scope="row">{toIndianCurrency(data.di.bill_amount_di)} </td>
                                            <td scope="row">{toIndianCurrency(data.ap.bill_amount_ap)} </td>

                                            <td scope="row">{toIndianCurrency(data.total.bill_amount)}</td>
                                        </tr>

                                        <tr>
                                            <td scope="row">Cack Back %</td>
                                            <td scope="row">{data.cashback_percent.ip_cashback}%</td>
                                            <td scope="row">{data.cashback_percent.op_pharma_cashback}%</td>
                                            <td scope="row">{data.cashback_percent.op_cashback}%</td>

                                            <td scope="row">{data.cashback_percent.ph_cashback}%</td>
                                            <td scope="row">{data.cashback_percent.di_cashback}%</td>
                                            <td scope="row">{data.cashback_percent.ap_cashback}%</td>

                                            <td scope="row">{data.cashback_percent.total_cashback_percent}%</td>
                                        </tr>
                                        <tr>
                                            <td scope="row">Cash Back Utilised %</td>
                                            <td scope="row">{(data.cashback_used_psercent.ip_cashback_used).toFixed(2)}%</td>
                                            <td scope="row">{(data.cashback_used_psercent.op_pharma_cashback_used).toFixed(2)}%</td>
                                            <td scope="row">{(data.cashback_used_psercent.op_cashback_used).toFixed(2)}%</td>

                                            <td scope="row">{(data.cashback_used_psercent.ph_cashback_used).toFixed(2)}%</td>
                                            <td scope="row">{(data.cashback_used_psercent.di_cashback_used).toFixed(2)}%</td>
                                            <td scope="row">{(data.cashback_used_psercent.ap_cashback_used).toFixed(2)}% </td>

                                            <td scope="row">{(data.cashback_used_psercent.total_cashback_used_percent).toFixed(2)}%</td>
                                        </tr>
                                    </tbody>
                                </table>}
                            </div>
                        </div>
                    </div>
                </div>
                <ReactTooltip
                    id="my-tooltip"
                    arrowColor="transparent"
                    place="bottom-start"
                    delayShow={50}
                    style={{
                        backgroundColor: "#707070",
                        fontSize: "10px",
                        textAlign: "center",
                        padding: "5px",
                        fontWeight: 400,
                    }}
                />
            </div>
        </>
    );
}
